var React = require('react');

function Phone (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M36.062 48a12.579 12.579 0 01-6.758-2h-.06A100.969 100.969 0 012.019 18.753 12.503 12.503 0 013.7 3.07l1.55-1.55a5.2 5.2 0 017.338 0l6.519 6.528a5.187 5.187 0 010 7.327 2.199 2.199 0 000 3.098l10.428 10.436a2.21 2.21 0 002.388.475 2.18 2.18 0 00.711-.475 5.189 5.189 0 017.338 0l6.52 6.507a5.197 5.197 0 010 7.337l-1.55 1.55A12.497 12.497 0 0136.062 48zm-5.149-4.508a9.53 9.53 0 0011.898-1.31l1.55-1.549a2.189 2.189 0 000-3.089l-6.519-6.517a2.191 2.191 0 00-3.1 0 5.19 5.19 0 01-7.328 0L17.016 20.631a5.197 5.197 0 010-7.337 2.189 2.189 0 000-3.088l-6.558-6.567a2.2 2.2 0 00-3.1 0l-1.55 1.549a9.505 9.505 0 00-1.3 11.895 97.899 97.899 0 0026.405 26.409z"}));
}

Phone.defaultProps = {"viewBox":"0 0 49 48"};

module.exports = Phone;

Phone.default = Phone;
